import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

function scroll(elementOffset) {
  window.scrollTo({top: elementOffset, behavior: 'smooth'})
}

export function scrollTo (ref, timeout = null) {
  let elementTop = ref.getBoundingClientRect().top
  let bodyTop = document.body.getBoundingClientRect().top
  let elementOffset = elementTop - bodyTop

  if (timeout) {
    setTimeout(() => {
      scroll(elementOffset)
    }, timeout)
  } else {
    scroll(elementOffset)
  }
}

export function scrollTop (elementId = 'vue-app') {
  let elementTop = document.getElementById(elementId)

  if (elementTop != null) {
    window.scrollTo({ top: elementTop.offsetTop, behavior: 'smooth'})
  }
}

export function dash (value) {
  return _.trim(value.replace(/[A-Z]/g, m => "-" + m.toLowerCase()), '-')
}